var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mounted
    ? _c(
        "div",
        [
          _vm.withTitle
            ? _c("h3", [_vm._v("Wird eine bestimmte Ausbildung benötigt?")])
            : _vm._e(),
          _vm._v(" "),
          _c("RadioGroup", {
            attrs: { options: _vm.yesNoOptions },
            on: { input: _vm.emitChangeEvent },
            model: {
              value: _vm.yesNo,
              callback: function($$v) {
                _vm.yesNo = $$v
              },
              expression: "yesNo"
            }
          }),
          _vm._v(" "),
          _vm.yesNo
            ? _c("div", { staticClass: "sections mt-4" }, [
                _c(
                  "section",
                  [
                    _c("h3", [_vm._v("Bitte wähle die Art der Ausbildung")]),
                    _vm._v(" "),
                    _vm.editSchoolType
                      ? _c("SelectInline", {
                          attrs: {
                            "characteristic-items": _vm.meta.schoolType,
                            "initial-show-all": "",
                            "single-choice": "",
                            "label-type": _vm.labelTypeJobProfile,
                            "description-config": { inline: true, html: true }
                          },
                          on: { input: _vm.setSchoolType },
                          model: {
                            value: _vm.schoolType,
                            callback: function($$v) {
                              _vm.schoolType = $$v
                            },
                            expression: "schoolType"
                          }
                        })
                      : _c(
                          "div",
                          [
                            _c("Label", {
                              attrs: {
                                characteristic: _vm.schoolTypeCharacteristic,
                                "label-type": _vm.labelTypeJobProfile
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "ml-1",
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    _vm.editSchoolType = true
                                  }
                                }
                              },
                              [
                                _c("Icon", {
                                  attrs: { icon: "edit", color: "primary" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.professionEligible
                  ? _c(
                      "section",
                      [
                        _c("h3", [
                          _vm._v(
                            "Muss die Ausbildung bestimmte fachliche Schwerpunkte haben?"
                          )
                        ]),
                        _vm._v(" "),
                        _c("RadioGroup", {
                          attrs: { options: _vm.yesNoOptions },
                          on: { input: _vm.professionsYesNoChanged },
                          model: {
                            value: _vm.professionsYesNo,
                            callback: function($$v) {
                              _vm.professionsYesNo = $$v
                            },
                            expression: "professionsYesNo"
                          }
                        }),
                        _vm._v(" "),
                        _vm.professionsYesNo
                          ? [
                              _c("CharacteristicEdit", {
                                ref: "professions",
                                staticClass: "mt-3",
                                attrs: {
                                  title:
                                    "Fachliche Schwerpunkte der Ausbildung",
                                  "with-keyword": true,
                                  "characteristic-type":
                                    _vm.meta.schoolProfessionType,
                                  "characteristic-items": _vm.schoolProfessions,
                                  "show-multiple-hint": "",
                                  "open-fan-button-alignment": "left",
                                  "open-fan-label":
                                    "Fachliche Schwerpunkte auswählen",
                                  "open-fan-label-with-selection":
                                    "Fachliche Schwerpunkte bearbeiten",
                                  "label-type": _vm.labelTypeJobProfile
                                },
                                on: { input: _vm.emitChangeEvent },
                                model: {
                                  value: _vm.professions,
                                  callback: function($$v) {
                                    _vm.professions = $$v
                                  },
                                  expression: "professions"
                                }
                              })
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }